// Simple kv preferences
import { Preferences } from '@capacitor/preferences';
import tts from '@/components/Chat/TTS';
import stt from '@/components/Chat/STT';

export async function set(key: string, val: any) {
    return await Preferences.set({key: key, value: JSON.stringify(val)})
}
window.set = set

export async function get(key: string): any {
    const { value } = await Preferences.get({ key: key })
    return JSON.parse(value!);
}
window.get = get

export async function get_or_set(key: string, val) {
    if (!await get(key)) {
        await set(key, val)
    }
    return await get(key)
}

window.get_or_set = get_or_set

export const languages = //['English', 'French', 'Spanish', 'Russian', 'Ukranian'];
{
    'English': 'en-US',
    'Spanish': 'es-ES',
    'French': 'fr-FR',
    'German': 'de-DE',
    'Russian': 'ru-RU',
    'Ukrainian': 'uk-UA',
    'Japanese': 'ja-JP',
    'Chinese': 'zh-CN',
    'Korean': 'ko-KR'
}

export type Language = keyof typeof languages;

const state = {
    onLanguageChange: [],
    onModelRoleChange: []
}

// language
async function loadLanguage(language: Language) { 
    tts.state.langcode = languages[language];
    stt.state.langcode = tts.state.langcode.split("-")[0]
}
export async function get_language() { return await get("language") }
export async function set_language(language: Language) {
    await set("language", language)

    loadLanguage(language);
    state.onLanguageChange.forEach(x => x());
}
export async function addOnLanguageChange(f) { state.onLanguageChange.push(f) }
export async function removeOnLanguageChange(f) {
    const idx = state.onLanguageChange.indexOf(f)
    if (idx > -1)
        state.onLanguageChange.splice(idx)
}

// model role
import narrator from './roles/narrator'
import teacher from './roles/teacher'
import researcher from './roles/researcher'
import debater from './roles/debater'
import skeptic from './roles/skeptic'
import duck from './roles/duck'

export const model_roles = {
    "Narrator": narrator,
    "Teacher": teacher,
    "Researcher": researcher,
    "Debater": debater,
    "Skeptic": skeptic,
    "Duck": duck,
    "User": ""
}

export type Role = keyof typeof model_roles;

// async function loadModelRole(role: ModelRole) {
//     //state.modelRole = role;
// }
export async function get_model_role() { return await get("modelRole") }
export async function set_model_role(role: Role) {
    await set("modelRole", role)

    //loadModelRole(role);
    state.onModelRoleChange.forEach(x => x());
}
export async function addOnModelRoleChange(f) { state.onModelRoleChange.push(f) }
export async function removeOnModelRoleChange(f) {
    const idx = state.onModelRoleChange.indexOf(f)
    if (idx > -1)
        state.onModelRoleChange.splice(idx)
}

const defaults = {
    "llmProvider": "Convolution",
    "sttProvider": "Convolution",
    //"language": "English",
    "shareConvolution": true,
    "sharePublic": false,
    "modelRole": "Narrator"
}

async function init() {
    for (const key in defaults) {
        if(await get(key)) continue;

        await set(key, defaults[key]);
    }

    // for language, let's try to be clever about it and load it from navigator.language
    if (!await get("language")) {
        const languageNames = new Intl.DisplayNames(['en'], {
            type: 'language'
        });
        let languageName = languageNames.of(navigator.language.split("-")[0])

        if (!languageName || !(languageName in languages)) {
            languageName = "English"
        }
        await set("language", languageName);
    }

    loadLanguage(await get_language())
    //oadModelRole(await get_model_role())
}

init();

export async function reset() {
    // TODO: remove

    set("llmProvider", "Convolution")
    set("sttProvider", "Convolution")
    set("language", "English")
    set("shareConvolution", true)
    set("sharePublic", false)

    // api keys
    set("cerebrasKey", "")
    set("geminiKey", "")
    set("openrouterKey", "")
    set("grokKey", "")
    set("openaiKey", "")
    set("anthropicKey", "")

    set("LLMcerebrasModel", "")
    set("LLMgeminiModel", "")
    set("LLMopenrouterModel", "")
    set("LLMgrokModel", "")
    set("LLMopenaiModel", "")
    set("LLManthropicModel", "")

    set("STTgrokModel", "")
    set("STTopenaiModel", "")
}

// IndexedDB preferences

import { openDB, deleteDB, wrap, unwrap } from 'idb';

async function getLLMKeysDB() {
    const name = "llmKeys"
    const version = 1
    const db = await openDB(name, version, {
        upgrade(db, oldVersion, newVersion, transaction, event) {
        // …
        }
    });

}

export default { get, set, get_or_set,
    languages, get_language, set_language, addOnLanguageChange, removeOnLanguageChange,
    model_roles, get_model_role, set_model_role, addOnModelRoleChange, removeOnModelRoleChange,
 }